"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var theme_1 = __importDefault(require("../../theme"));
var SliderController = react_1.memo(function (_a) {
    var onChange = _a.onChange, value = _a.value, showLabels = _a.showLabels, inputProps = __rest(_a, ["onChange", "value", "showLabels"]);
    var _b = react_1.useState(0), sliderVal = _b[0], setSliderVal = _b[1];
    var _c = react_1.useState(null), mouseState = _c[0], setMouseState = _c[1];
    react_1.useEffect(function () {
        setSliderVal(value);
    }, [value]);
    react_1.useEffect(function () {
        if (mouseState === "up") {
            onChange(sliderVal);
        }
    }, [mouseState]);
    return (react_1.default.createElement(styles_1.Input, __assign({ id: "sliderInput", type: "range", percent: sliderVal + "%", value: sliderVal }, inputProps, { onChange: function (event) { return setSliderVal(event.target.value); }, onMouseDown: function () { return setMouseState("down"); }, onMouseUp: function () { return setMouseState("up"); } })));
});
function Slider(props) {
    var _a = react_1.useState(props.value), parentVal = _a[0], setParentVal = _a[1];
    var sliderValueChanged = react_1.useCallback(function (value) {
        setParentVal(value);
        props.setValue(value);
    }, []);
    var controllerProps = react_1.useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        return ({
            min: props.min || 0,
            max: props.max || 100,
            value: parentVal,
            step: 2,
            onChange: function (event) {
                sliderValueChanged(event);
            },
            style: {
                root: ((_a = props.style) === null || _a === void 0 ? void 0 : _a.root) || {},
                track: {
                    backgroundColor: ((_c = (_b = props.style) === null || _b === void 0 ? void 0 : _b.track) === null || _c === void 0 ? void 0 : _c.backgroundColor) ||
                        theme_1.default.colorsPalette.blue.default,
                    height: ((_e = (_d = props.style) === null || _d === void 0 ? void 0 : _d.track) === null || _e === void 0 ? void 0 : _e.height) || "3px",
                },
                thumb: {
                    backgroundColor: ((_g = (_f = props.style) === null || _f === void 0 ? void 0 : _f.thumb) === null || _g === void 0 ? void 0 : _g.backgroundColor) ||
                        theme_1.default.colorsPalette.blue.default,
                    height: ((_j = (_h = props.style) === null || _h === void 0 ? void 0 : _h.track) === null || _j === void 0 ? void 0 : _j.height) || "14px",
                },
                rail: {
                    backgroundColor: ((_l = (_k = props.style) === null || _k === void 0 ? void 0 : _k.track) === null || _l === void 0 ? void 0 : _l.backgroundColor) ||
                        theme_1.default.colorsPalette.gray.lighter,
                    height: ((_o = (_m = props.style) === null || _m === void 0 ? void 0 : _m.track) === null || _o === void 0 ? void 0 : _o.height) || "3px",
                },
            },
            showLabels: !!props.showLabels,
        });
    }, [parentVal]);
    return react_1.default.createElement(SliderController, __assign({}, controllerProps));
}
exports.default = Slider;
//# sourceMappingURL=index.js.map